export const getJobsData = state => {
  return state.data.jobs;
};
export const getMovementsData = state => {
  return state.data.movements;
};
export const getTrackingCategoriesData = state => {
  return state.data.trackingCategories;
};
export const getSummaryFiguresData = state => {
  return state.data.summaryFigures;
};
export const getJobWorkshopConfigData = state => {
  return state.data.workshopConfig;
};
export const getDefaultWorkData = state => {
  return state.data.defaultWork;
}
export const getInvoiceFiguresData = state => {
  return state.data.invoiceFigures;
};
export const getFitterHoursData = state => {
  return state.data.fitterHours;
};
export const getTrackingOptionsData = state => {
  return state.data.trackingOptions;
};
export const getQuotesData = state => {
  return state.data.quotes;
};
export const getMovementData = state => {
  return state.data.movement
}
export const getNominalCodesData = state => {
  return state.data.nominalCodes;
};
export const getMovementFiguresData = state => {
  return state.data.movementFigures;
};
export const getDriversData = state => {
  return state.data.drivers;
};
export const getRateCardsData = state => {
    return state.data.rateCards;
};
export const getMovementTypesData = state => {
  return state.data.movementTypes;
};
export const getCapTotalsData = state => {
  return state.data.capTotals;
};
export const getInvoicesData = state => {
  return state.data.invoices;
};
export const getMovementRatesData = state => {
  return state.data.movementRates;
};
export const getCreditNotesData = state => {
  return state.data.creditNotes;
};
export const getPaymentTypesData = state => {
  return state.data.paymentTypes;
};
export const getVehicleModelData = state => {
  return state.data.vehicleModel;
};
export const getWorkTypeData = state => {
  return state.data.workType;
};
export const getJobStatusCountData = state => {
  return state.data.jobStatusCount;
};
export const getServiceData = state => {
  return state.data.serviceData;
};
export const getVehicleTrackerTypeData = state => {
  return state.data.vehicleTrackerType;
};
export const getVehicleTrackerFiguresData = state => {
  return state.data.vehicleTrackerFigures;
};
export const getImagesData = state => {
  return state.data.images;
};
export const getVehicleStatusCount = state => {
  return state.data.vehicleStatusCount;
};
export const getKeysData = state => {
  return state.data.keys;
}

export const getFittersData = state => {
  return state.data.fitters;
}

export const getDepartmentsData = state => {
  return state.data.departments;
}

export const getPartsData = state => {
  return state.data.parts;
};

export const getPartLookupData = state => {
  return state.data.partLookup;
};

export const getPartOrdersData = state => {
  return state.data.partOrders;
};

export const getPartOrderData = state => {
  return state.data.partOrder;
};

export const getWorkLookupData = state => {
  return state.data.workLookup;
};

export const getRentalsData = state => {
  return state.data.rentals;
};

export const getRentalData = state => {
  return state.data.rental;
};

export const getRentalInvoiceData = state => {
  return state.data.rentalInvoices;
};

export const getRentalMarginData = state => {
  return state.data.rentalMargin;
};

export const getUserData = state => {
  return state.data.user;
};

export const getTransactionData = state => {
  return state.data.transactions;
};

export const getWeeklyTransactionData = state => {
  return state.data.weeklyTransactions;
};

export const getPartOrderFigureData = state => {
  return state.data.partOrderFigure
}

export const getDataFresh = state => {
  return state.data.dataFresh;
};

export const getFixedExpensesData = state => {
  return state.data.fixedExpenses;
};

export const getDefectCountData = state => {
  return state.data.defectCount;
}
export const getEnquiryCountData = state => {
  return state.data.enquiryCount;
}
export const getTransactionFiguresData = state => {
  return state.data.figures.transactionData;
};
export const getVehicleSummaryFiguresData = state => {
  return state.data.figures.vehicleSummary;
}
export const getWorkFiguresData = state => {
  return state.data.figures.workFigures;
};

export const getHomeTotalsData = state => {
  return state.data.homeTotals;
};

export const getPartFiguresData = state => {
  return state.data.figures.partFigures;
};

export const getRentalFiguresData = state => {
  return state.data.figures.rentalFigures;
};

export const getVehicleFiguresData = state => {
  return state.data.figures.vehicleFigures;
};

export const getExistingJobsData = state => {
  return state.data.exisingJobs;
};

export const getServicePacksData = state => {
  return state.data.servicePacks;
};

export const getTargetFiguresData = state => {
  return state.data.figures.target;
};

export const getTargetsData = state => {
  return state.data.targets;
};

export const getInspectionTypesData = state => {
  return state.data.inspectionTypes;
};

export const getInspectionData = state => {
  return state.data.inspections;
};

export const getVehicleTypesData = state => {
  return state.data.vehicleTypes;
};

export const getQuickLinksData = state => {
  return state.data.quickLinks;
};

export const getTransactionCategoriesData = state => {
  return state.data.transactionCategories;
};

export const getTransactionReportingCategoriesData = state => {
  return state.data.transactionReportingCategories;
};

export const getCostCentresData = state => {
  return state.data.costCentres;
};

export const getVehicleData = state => {
  return state.data.vehicle;
};

export const getFinanceData = state => {
  return state.data.finance;
};

export const getJobData = state => {
  return state.data.job;
};

export const getQuoteData = state => {
  return state.data.quote;
};

export const getDiaryData = state => {
  return state.data.diary;
};

export const getWorkData = state => {
  return state.data.work;
};

export const getVehiclesData = state => {
  return state.data.vehicles;
};

export const getVehicleSummaryData = state => {
  return state.data.vehicleSummary;
};

export const getAppDefaultsData = state => {
  return state.data.appDefaults;
};

export const getContactData = state => {
  return state.data.contact;
};

export const getContactsData = state => {
  return state.data.contacts;
};

export const getPaymentsData = state => {
  return state.data.payments;
};

export const getVehicleTrackersData = state => {
  return state.data.trackers;
}

export const getRecurringPaymentsData = state => {
  return state.data.recurringPayments;
}

export const getVehicleMakeData = state => {
  return state.data.vehicleMake;
}